import API from 'js/lib/api';
import type { ApiOptions } from 'js/lib/api';

const apiWrapper = function (endpoint: string, options?: ApiOptions) {
  return API(endpoint, options);
};

export default apiWrapper;
